import { useCallback, useRef, useState } from 'react';

import type { MouseEvent } from 'react';

interface UsePhoneClientMenuProps {
  onSelect(clientId: number): void;
}

// Меню клиентов под полем «Мобильный телефон» (task/11629). Ширина меню
// равна ширине поля, как у списка поля «Поиск».
export const usePhoneClientMenu = ({ onSelect }: UsePhoneClientMenuProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [menuWidth, setMenuWidth] = useState(0);

  const updateMenuWidthHandler = useCallback(() => {
    if (containerRef.current) {
      setMenuWidth(containerRef.current.offsetWidth);
    }
  }, []);

  // Нажатие в меню не уводит фокус из поля телефона: иначе меню закрылось
  // бы до клика по клиенту.
  const menuMouseDownHandler = useCallback((event: MouseEvent) => {
    event.preventDefault();
  }, []);

  const getOptionClickHandler = useCallback(
    (clientId: number) => () => onSelect(clientId),
    [onSelect]
  );

  return {
    containerRef,
    menuWidth,
    updateMenuWidthHandler,
    menuMouseDownHandler,
    getOptionClickHandler,
  };
};
